module.exports = __webpack_public_path__ + "static/assets/0408e986e15e0f56aefc6e9719fa42e3.gif";